export default __webpack_public_path__ + "static/paperbag-5539691ca358639151b656941c6f7d5f.png";